<template>
  <div class="container">
    <h1 class="title text-uppercase font-weight-bold mt-5">
      Solicitar App
    </h1>

    <div class="row mt-5">
        <div class="col-6">
            <div class="text-center">
                <img src="../../src/assets/img/app.png" class="size-img-app img-fluid rounded" alt="Celular mostrando app"></img>
            </div>
        </div>
        
        <div class="col-6">
            <h1 class="mt-3">Gostaria de ter seu próprio aplicativo e pagar pela comissão só quando vender?</h1>
            <h3 class="mt-4">
              A mesma comissão da plataforma, <strong><span class="c-orange">4,0%</span> + taxa de transação</strong> da IUGU.
            </h3>
            <h4 class="c-black mt-4">
              * Pagamento mínimo mensal de {{ planosApp[0].preco }} descontado da comissão.
            </h4>
            <h3 class="mt-4">É muito fácil, é só clicar no botão abaixo.</h3>
            <router-link
              class="p-2 btn bg-orange c-white mt-3 btn-block"
              class-active="active"
              :to="{ name: 'cadastro', params: { type: 3, from: 'menu-item' } }"
            >
              Solicitar agora
            </router-link>
        </div>
    </div>

    <div class="bg-orange mt-5 c-white text-center p-5">
        <h1 class="pt-4 mb-4">Vantagens em ter seu próprio aplicativo</h1>
        <div class="row">
            <div class="col-md mt-2">
                <img src="../../src/assets/img/grafico40.png" class="img-grafico img-fluid rounded" alt="Grafico de barras 40%"></img>
                <h5 class="card-text mt-2">Desde o inicio da pandemia, as compras realizadas pela internet no Brasil aumentaram em 40%</h5>
            </div>
            
            <div class="col-md mt-4">
                 <img src="../../src/assets/img/grafico76.png" class="img-grafico img-fluid rounded" alt="Grafico de pizza porcentagem 76%"></img>
                <h5 class="card-text mt-4">de todas comprar online, 76% são feitas por celulares</h5>
            </div>

            <div class="col-md mt-3">
                <img src="../../src/assets/img/grafico85.png" class="img-grafico img-fluid rounded" alt="Grafico de pizza porcentagem 85%"></img>
                <h5 class="card-text mt-4">85% dos brasileiros com celular compram online</h5>
            </div>
  
        </div>
    </div>

    <div class="row mt-5">
        <h1 class="mb-4 text-center titleCustom">Customizações que você pode fazer no seu aplicativo</h1>

        <div class="col-md-6 mt-5">
            <ul>
                <li> 
                    <h3 class="card-text">Personalizar as <span class="c-orange">cores</span>, o <span class="c-orange">logo</span> e 
                    <span class="c-orange">nome</span> do aplicativo</h3>
                </li>
                <li class="mt-4">
                     <h3 class="card-text">Personalizar os <span class="c-orange">banners</span> do aplicativo.</h3>
                </li>
            </ul>
        </div>

        <div class="col-md">
            <img src="../../src/assets/img/seu-banner.png" class="size-img-app img-fluid rounded" alt="Celular mostrando app"></img>
        </div>
    </div>

     <div class="row mt-3 mb-3">
        <div class="col-md mt-5">
            <img src="../../src/assets/img/lista-produtos.png" class="-app img-fluid rounded" alt="Celular mostrando app"></img>
        </div>
        <div class="col-md-6 mt-5">
            <ul>
                <li> 
                    <h4 class="card-text color-brack">
                        Selecione os <span class="c-orange">produtos</span> para vender, sem precisar cadastrar os
                        produtos, já temos mais de <span class="c-orange">200.000</span> produtos cadastrados.
                    </h4>
                </li>
                <li class="mt-4">
                     <h3 class="card-text">Recados, <span class="c-orange">promoções</span>, novidades, notificação instantânea via Push.</h3>
                </li>
                <li class="mt-4">
                    <h3 class="card-text">Todas suas <span class="c-orange">redes sociais</span> no aplicativo.</h3>
                </li>
            </ul>
        </div>
    </div>

    <div class="pt-3 bg-orange c-white">
        <div class="mb-3">
            <h1 class="text-center">Por que ter um aplicativo criado por nós?</h1>
        </div>
        <div class="row p-5">
            <div class="col">
                <div class="text-center rounded-circle bg-orange">
                    <i class="fas fa-building icon-size"></i> 
                </div>
                <div class="text-center mt-4">
                    <h5>Em poucos cliques, configure tudo</h5>
                </div>
            </div>

             <div class="col">
                <div class="text-center rounded-circle bg-orange">
                    <i class="fa fa-dollar-sign icon-size"></i>
                </div>
                <div class="text-center mt-4">
                    <h5>Sem mensalidade ou anuidades</h5>
                </div>
            </div>

             <div class="col">
                <div class="text-center rounded-circle bg-orange">
                    <i class="fas fa-building icon-size"></i>   
                </div>
                <div class="text-center mt-4">
                    <h5>Receba o dinheiro na sua conta</h5>
                </div>
            </div>

             <div class="col">
                <div class="text-center rounded-circle bg-orange">
                    <i class="fa fa-dollar-sign icon-size"></i> 
                </div>
                <div class="text-center mt-4">
                    <h5>Baixa comissão de venda</h5>
                </div>
            </div>

             <div class="col">
                <div class="text-center rounded-circle bg-orange">
                    <i class="fa fa-globe icon-size"></i>
                </div>
                <div class="text-center mt-4">
                    <h5>Venda online sem investir em uma plataforma própria</h5>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import scrollToElement from '../mixins/scrollToElement';

export default {
  mixins: [scrollToElement],
  name: 'SolicitarAppSemLogin',

  data(){
    return {
      planosApp: '',
    }
  },
  
  created() {
    if(this.$route.query && this.$route.query.value) {
      this.$router.push({ name: 'cadastro', params: { type: 3, from: 'menu-item', value: this.$route.query.value }});
    }
    this.scrollToElement();
    this.showPlanos();
  },
  mounted() {
    this.scrollToElement();
  },
  methods: {
    showPlanos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/showPlanosApp')
      .then((response) => {
        this.planosApp = response.data;
        this.$store.dispatch('endLoader');
      })
    },
  }
};
</script>

<style scoped>
.size-img-app {
  max-width: 380px;
}
.img-grafico {
  max-width: 250px;
}
.icon-size {
  font-size: 60px;
}

@media (max-width: 800px){
.size-img-app {
  width: 100%;
}
h1 {
  font-size: 25px;
}
h3 {
  font-size: 18px;
}
h5 {
  font-size: 16px;
}
.bg-orange{
  width: 100%;
}
.titleCustom {
  margin-left: 7%;
}
.text-uppercase {
  margin-left: 2%;
}
.linha-amarela {
  margin-left: 2%;
}
}
</style>